// chat.2factor.finance = 2Factor's "Ask Claude" research assistant (the chat dev's service). It answers from a fixed
// corpus that includes this program's landing + Terms pages and our knowledge base (the gist published from
// 2factor-points-program-knowledge-base.md), so a wrong answer is fixed THERE, not here.
// `/?q=<question>` types the question into its composer and sends it on arrival; it keeps the first 500 chars.
export const CHAT_URL = 'https://chat.2factor.finance/';
export const ASK_MAX = 500;

export function askUrl(q?: string) {
  const text = q?.trim().slice(0, ASK_MAX);
  return text ? `${CHAT_URL}?q=${encodeURIComponent(text)}` : CHAT_URL;
}
